
import { createMuiTheme, makeStyles, createStyles  } from '@material-ui/core/styles';
export const theme = createMuiTheme()
export const table = theme => ({

    // styles-table
//    table_cell: {
//        padding : '0px 4px 0px 4px',
//        fontSize: '0.8125rem'
//    },
//    table_cell_nowrap: {
//        whiteSpace: 'nowrap',
//        padding : '0px 4px 0px 4px',
//        fontSize: '0.8125rem'
//    },
//
//
//    table_header_compact: {
//        padding : '0px 4px 0px 4px',
//        height: '24px',
//        backgroundColor: '#E3EDF6',
//    },
//    table_header_short: {
//        padding : '0px 4px 0px 4px',
//        height: '32px',
//        backgroundColor: '#E3EDF6',
//    },
//    table_header_default: {
//        padding : '0px 4px 0px 4px',
//        height: '48px',
//        backgroundColor: '#E3EDF6',
//    },
//    table_header_tall: {
//        padding : '0px 4px 0px 4px',
//        height: '64px',
//        backgroundColor: '#E3EDF6',
//    },
//
//    table_cell_compact: {
//        padding : '0px 4px 0px 4px',
//        height: '24px',
//        backgroundColor: '#F4F6F8',
//    },
//    table_cell_short: {
//        padding : '0px 4px 0px 4px',
//        height: '32px',
//        backgroundColor: '#F4F6F8',
//    },
//    table_cell_default: {
//        padding : '0px 4px 0px 4px',
//        height: '48px',
//        backgroundColor: '#F4F6F8',
//    },
//    table_cell_tall: {
//        padding : '0px 4px 0px 4px',
//        height: '64px',
//        backgroundColor: '#F4F6F8',
//    },


    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginRight: -8
        }
    },
    expandOpen: {
        transform: 'rotate(180deg)'
    },


})


// WEBPACK FOOTER //
// ./src/components/CSS/table.js